import type {
  CreateInfraFacilityPayload,
  CreateInfraFacilityResponse,
  DeleteInfraFacilityResponse,
  InfraFacilityDetailResponse,
  InfraFacilityID,
  InfraFacilityListResponse,
  UpdateInfraFacilityParams,
  UpdateInfraFacilityPayload,
  UpdateInfraFacilityResponse,
} from '@/domains/asset-management/types/infra-facility';
import { APIS, URLS } from '@/shared/config/urls';
import { request } from '@/shared/utils/request';

const toUrlID = (id: string | number): string => String(id);

export const fetchInfraFacilityList = async (
  params: string = ''
): Promise<InfraFacilityListResponse> => {
  const url = `${URLS.BACK_DSH}${APIS.infraFacilityList(params)}`;
  return await request.get(url);
};

export const fetchDetailInfraFacility = async (
  id: InfraFacilityID
): Promise<InfraFacilityDetailResponse> => {
  const url = `${URLS.BACK_DSH}${APIS.detailInfraFacility(toUrlID(id))}`;
  return await request.get(url);
};

export const deleteInfraFacility = async (
  id: InfraFacilityID
): Promise<DeleteInfraFacilityResponse> => {
  const url = `${URLS.BACK_DSH}${APIS.deleteInfraFacility(toUrlID(id))}`;
  return await request.delete(url);
};

export const createInfraFacility = async (
  data: CreateInfraFacilityPayload
): Promise<CreateInfraFacilityResponse> => {
  const url = `${URLS.BACK_DSH}${APIS.createInfraFacility}`;
  return await request.post(url, data);
};

export const updateInfraFacility = async (
  data: UpdateInfraFacilityPayload,
  params: UpdateInfraFacilityParams
): Promise<UpdateInfraFacilityResponse> => {
  const url = `${URLS.BACK_DSH}${APIS.updateInfraFacility(toUrlID(params.infra_and_facility_id))}`;
  return await request.put(url, data);
};
